var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75008 4.5H7.37708C7.01358 4.50025 6.6615 4.62698 6.38122 4.85844C6.10094 5.0899 5.90993 5.41167 5.84095 5.76856C5.77197 6.12545 5.82932 6.49523 6.00317 6.81446C6.17701 7.13369 6.45652 7.38248 6.79374 7.51817L9.20058 8.48067C9.53855 8.61587 9.81886 8.86461 9.99328 9.18412C10.1677 9.50362 10.2253 9.87392 10.1563 10.2313C10.0872 10.5887 9.89582 10.9109 9.61493 11.1425C9.33405 11.374 8.98126 11.5004 8.61724 11.5H6.25008",
    stroke: "#686781",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5V3.625",
    stroke: "#686781",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.375V11.5",
    stroke: "#686781",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
    stroke: "#686781",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.86653237858437017044f47eaf2804a4.svg";
export { ForwardRef as ReactComponent };